import { render, staticRenderFns } from "./ZoneDiseaseReportPhrases.vue?vue&type=template&id=096688f7&scoped=true"
import script from "./ZoneDiseaseReportPhrases.vue?vue&type=script&lang=js"
export * from "./ZoneDiseaseReportPhrases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096688f7",
  null
  
)

export default component.exports